<template lang="pug">
.error
  i.error-icon.material-icons info_outline
  span.error-text {{ text }}
</template>

<script>
export default {
  layout: 'default',
  props: {
    error: { type: Object },
  },
  computed: {
    text() {
      switch (this.error.statusCode) {
        case 404:
          return 'Página não encontrada'
        default:
          return 'Erro desconhecido'
      }
    },
  },
}
</script>

<style lang="sass">
.error
  background: #FFF
  height: calc(100vh - 100px)
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  &-icon
    font-size: 100px
    opacity: .5
  &-text
    margin-top: 24px
    font-size: 24px
</style>
